/**
 * Panel definitions for forward/emissions commodity
 * Add your emissions-related panels here based on backend dataset configs
 */
export const forwardEmissionsPanels = [
  // First row: 2 panels side-by-side (12 cols each)
  {
    id: 'eua-forward-curve',
    type: 'datasetChart',
    datasetId: 'ice-eua-futures',
    visualizationId: 'eua-futures-forward-curve',
    labelOverrides: { descriptionKey: 'dashboard_panels.emissions_forward_curve' },
    gridPos: { x: 0, y: 0, w: 8, h: 14 },
  },
  {
    id: 'eua-monthly-settlements',
    type: 'datasetChart',
    datasetId: 'ice-eua-futures',
    visualizationId: 'eua-futures-monthly-settlements',
    gridPos: { x: 8, y: 0, w: 8, h: 14 },
  },

  // Second row: 1 panel full width (24 cols)
  {
    id: 'eua-front-month',
    type: 'datasetChart',
    datasetId: 'ice-eua-futures',
    visualizationId: 'eua-futures-front-month-daily',
    gridPos: { x: 16, y: 0, w: 8, h: 14 },
  },
];

export const forwardEmissionsSyncGroups = [
  {
    id: 'emissions-first-row',
    global: false,
    ids: ['eua-forward-curve', 'eua-monthly-settlements', 'eua-front-month'],
    syncAxes: { y: true },
  },
];
